import React from "react";
import Tabs from "../../../elements/Tabs";
import Auth2FA from "./Auth2FA";

const PrivacyAndSecurity = () => {
  const tabs = [
    {
      label: "Multi-Factor Email Authentication (2FA)",
      icon: "fa-light fa-user",
      content: <Auth2FA />,
    },
  ];
  return (
    <div>
      <Tabs items={tabs} type="menu" />
    </div>
  );
};

export default PrivacyAndSecurity;
